<template>
    <Modal :modal-title="title"
           :dialog="groupFormVisibility"
           max-width="600px"
           :persistent="true"
           dense
           data-test="modal"
           @keydown.enter="showConfirmation"
           @keydown.esc="closeWithConfirmation"
           @close="close"
           @visibility="visibility($event)">
        <template v-slot:content>
            <ManageEmployeesGroupForm ref="form"></ManageEmployeesGroupForm>
            <ConfirmationDialog :dialog="showConfirmationDialog"
                                data-test="ConfirmationDialog"
                                @confirm="handleConfirmation($event)"
                                :text="$t('messages.save_changes')"
                                :action-button-title="$t('buttons.save')"></ConfirmationDialog>
            <ValidationError v-if="showError"></ValidationError>
        </template>

        <template v-slot:footer>
            <v-btn color="secondary"
                   outlined
                   data-test="closeBtn"
                   @click="close">{{ $t('buttons.cancel') }}</v-btn>
            <v-btn color="secondary"
                   data-test="saveBtn"
                   :loading="loader"
                   :disabled="loader"
                   @click="save">
                <v-icon left>
                    {{ ICONS.SAVE}}
                </v-icon>
                {{ $t('buttons.save') }}</v-btn>
        </template>
    </Modal>
</template>

<script>
import { mapState } from 'vuex';
import Modal from '@/components/templates/Modal';
import ConfirmationDialog from '@/components/widgets/dialogs/ConfirmationDialog';
import ManageEmployeesGroupForm from '@/components/employeesGroups/manageEmployeesGroup/ManageEmployeesGroupForm';
import ValidationError from '@/components/widgets/ValidationError';
import { ICONS } from '@/constants/icons';

export default {
    name: 'ManageEmployeesGroup',
    components: { Modal, ConfirmationDialog, ManageEmployeesGroupForm, ValidationError },
    data: () => ({
        ICONS,
        showConfirmationDialog: false,
        loader: false,
        showError: false
    }),
    computed: {
        ...mapState('manageEmployeesGroup', [
            'groupFormVisibility',
            'editedGroupId'
        ]),
        isFieldsDirty () {
            return this.$refs.form.isFormDirty;
        },
        isEditable () {
            return this.editedGroupId !== null;
        },
        title () {
            return this.isEditable
                ? this.$t('configurations.employees_groups.edit_title')
                : this.$t('configurations.employees_groups.add_title');
        }
    },
    methods: {
        close () {
            this.$store.commit('manageEmployeesGroup/SET_GROUP_FORM_VISIBILITY', false);
            this.$refs.form.resetValidation();
            // prevent showing bad data 0.1s
            setTimeout(() => {
                this.$store.commit('manageEmployeesGroup/RESET_GROUP_DATA');
                if (this.isEditable) {
                    this.$store.commit('manageEmployeesGroup/SET_EDITED_GROUP_ID', null);
                }
                this.showError = false;
            }, 100);
        },
        visibility (event) {
            this.$store.commit('manageEmployeesGroup/SET_GROUP_FORM_VISIBILITY', event);
        },
        closeWithConfirmation () {
            if (this.isFieldsDirty) {
                this.showConfirmationDialog = true;
            } else {
                this.close();
            }
        },
        showConfirmation () {
            if (this.isFieldsDirty) {
                this.showConfirmationDialog = true;
            }
        },
        updateEmployeesGroup () {
            this.loader = true;

            this.$refs.form.validate()
                .then(valid => {
                    this.showError = !valid;
                    if (valid) {
                        return this.$store.dispatch('manageEmployeesGroup/updateEmployeesGroup')
                            .then(() => {
                                this.$emit('fetch');
                                this.close();
                            })
                            .finally(() => {
                                this.loader = false;
                            });
                    } else {
                        this.loader = false;
                    }
                });
        },
        createEmployeesGroup () {
            this.loader = true;

            this.$refs.form.validate()
                .then(valid => {
                    this.showError = !valid;
                    if (valid) {
                        return this.$store.dispatch('manageEmployeesGroup/createEmployeesGroup')
                            .then(() => {
                                this.$emit('fetch');
                                this.close();
                            })
                            .finally(() => {
                                this.loader = false;
                            });
                    } else {
                        this.loader = false;
                    }
                });
        },
        save () {
            if (this.isEditable) {
                this.updateEmployeesGroup();
            } else {
                this.createEmployeesGroup();
            }
        },
        handleConfirmation (event) {
            if (event) {
                this.save();
                this.showConfirmationDialog = false;
            } else {
                this.showConfirmationDialog = false;
            }
        }
    }
};
</script>

<style scoped>

</style>
